@switch (status()) {
  @case ('loading') {
    <div class="viewer-state" role="status">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      <p>Chargement du document…</p>
    </div>
  }
  @case ('error') {
    <div class="viewer-state" role="alert">
      <p class="viewer-state-title">Le document n’a pas pu être chargé.</p>
      <p>{{ errorMessage() }}</p>
      <button matButton="outlined" aria-label="Réessayer le chargement" (click)="reload()">
        Réessayer
      </button>
    </div>
  }
  @case ('ready') {
    @if (kind() === 'image' || kind() === 'pdf') {
      <div class="viewer-toolbar" role="toolbar" aria-label="Affichage du document">
        <button
          matIconButton
          aria-label="Réduire"
          matTooltip="Réduire"
          (click)="zoomOut()"
          [disabled]="zoom() <= minZoom"
        >
          <svg lucideMinus></svg>
        </button>
        <span class="zoom-label">{{ zoom() * 100 | number: '1.0-0' }}%</span>
        <button
          matIconButton
          aria-label="Agrandir"
          matTooltip="Agrandir"
          (click)="zoomIn()"
          [disabled]="zoom() >= maxZoom"
        >
          <svg lucidePlus></svg>
        </button>
        @if (kind() === 'image' && rotatable()) {
          <span class="toolbar-separator"></span>
          <button
            matIconButton
            aria-label="Faire pivoter dans le sens inverse des aiguilles d’une montre"
            matTooltip="Faire pivoter dans le sens inverse des aiguilles d’une montre"
            (click)="rotate(1, 'counterclockwise')"
          >
            <svg lucideRotateCcw></svg>
          </button>
          <button
            matIconButton
            aria-label="Faire pivoter dans le sens des aiguilles d’une montre"
            matTooltip="Faire pivoter dans le sens des aiguilles d’une montre"
            (click)="rotate(1, 'clockwise')"
          >
            <svg lucideRotateCw></svg>
          </button>
        }
      </div>
      @if (unsavedPages().length > 0) {
        <div class="viewer-warning" role="alert">
          <svg lucideTriangleAlert></svg>
          <span>
            L’orientation n’a pas pu être enregistrée
            @if (kind() === 'pdf') {
              (page{{ unsavedPages().length > 1 ? 's' : '' }} {{ unsavedPages().join(', ') }})
            }
            : le document reste affiché ainsi pour vous, mais l’orientation ne sera pas retenue pour
            les prochaines consultations.
          </span>
        </div>
      }
      <div
        class="preview-wrapper"
        #previewWrapper
        [class.dragging]="isDragging()"
        (pointerdown)="startDrag($event)"
        (pointermove)="drag($event)"
        (pointerup)="endDrag()"
        (pointercancel)="endDrag()"
        (lostpointercapture)="endDrag()"
      >
        @if (kind() === 'image') {
          <canvas
            #imageCanvas
            class="image-preview"
            role="img"
            [attr.aria-label]="document().name || 'Document'"
          ></canvas>
        } @else {
          @if (pdf(); as file) {
            @for (page of pages(); track page) {
              <app-pdf-page-view
                [file]="file"
                [pageNumber]="page"
                [pageCount]="file.pageCount"
                [rotation]="orientationOf(page)"
                [zoom]="zoom()"
                [availableWidth]="availableWidth()"
                [rotatable]="rotatable()"
                [scrollRoot]="previewWrapper"
                (turned)="rotate(page, $event)"
                (openOriginal)="originalRequested.emit()"
              ></app-pdf-page-view>
            }
          } @else {
            <div class="viewer-state" role="status">
              <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
              <p>Préparation du PDF…</p>
            </div>
          }
        }
      </div>
    } @else {
      <div class="viewer-state" role="status">
        <p class="viewer-state-title">Ce format de fichier ne peut pas être affiché ici.</p>
        <p>
          La visionneuse n’affiche que les images et les PDF. Téléchargez le document pour l’ouvrir
          avec une autre application.
        </p>
        <button
          matButton="filled"
          aria-label="Télécharger le document"
          (click)="downloadRequested.emit()"
        >
          Télécharger
        </button>
      </div>
    }
  }
}
